import { useEffect } from "react";
import { X } from "lucide-react";

// Reliable cross-device fullscreen (fixed overlay, works on iOS/iPadOS Safari
// where Element.requestFullscreen is unsupported).
export const FullscreenOverlay = ({ open, onClose, children, title, zClass = "z-[70]" }) => {
  useEffect(() => {
    if (open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      const onKey = (e) => e.key === "Escape" && onClose();
      window.addEventListener("keydown", onKey);
      return () => {
        document.body.style.overflow = prev;
        window.removeEventListener("keydown", onKey);
      };
    }
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className={`fixed inset-0 ${zClass} flex flex-col bg-[#fdfbf7]`} data-testid="fullscreen-overlay">
      <div className="flex shrink-0 items-center justify-between border-b border-[#e5e0d8] px-4 py-3">
        <span className="truncate pr-2 font-serif text-xl font-bold text-[#2d2824]">{title}</span>
        <button
          onClick={onClose}
          className="flex shrink-0 items-center gap-1.5 rounded-full bg-[#2d2824] px-4 py-2 text-sm font-bold text-white"
          data-testid="fullscreen-close"
        >
          <X className="h-4 w-4" /> Close
        </button>
      </div>
      <div className="flex-1 overflow-auto p-4 sm:p-6">{children}</div>
    </div>
  );
};
